/**
 * Country switcher popup 1 (sections/switch-currency.liquid).
 *
 * Opens once per browser session when the visitor appears to be browsing from
 * outside the country they have selected - a UK IP stays quiet on the UK market,
 * anyone else on it is greeted with "Hello, United Kingdom" and its USPs.
 * "Continue shopping" closes it; "Click here" hands over to popup 2, the country
 * list in snippets/cs-popup.liquid.
 *
 * Country detection has two sources, tried in this order:
 *
 *   1. Shopify's own browsing context suggestions. First party, needs no app,
 *      and works on every store.
 *   2. Cozy Country Redirect (window.CozyCountryRedirect), the historical
 *      source. Only consulted if Shopify returns nothing, and only for as long
 *      as COZY_TIMEOUT_MS, so a store without the app installed is not held up.
 */
(function () {
    // Session cookie - no Max-Age, so it dies with the browser and is shared
    // across tabs. sessionStorage would be per-tab, which would re-prompt anyone
    // who opens a product in a new tab.
    var COOKIE = 'nl_cs_prompt';
    var COZY_TIMEOUT_MS = 3000;
    var COZY_POLL_MS = 200;

    function onReady(callback) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', callback);
        } else {
            callback();
        }
    }

    function seenThisSession() {
        return document.cookie.split('; ').indexOf(COOKIE + '=1') > -1;
    }

    function markSeen() {
        try {
            document.cookie = COOKIE + '=1; path=/; SameSite=Lax';
        } catch (error) {
            // Cookies blocked: the popup simply offers itself again next page.
        }
    }

    // Where the visitor is, by IP. Deliberately not excluding the selected
    // country from the request: a visitor who is where they have selected is
    // exactly the case that must come back as a match.
    function shopifyDetectedCountry() {
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var url = root + 'browsing_context_suggestions.json?country[enabled]=true';

        return fetch(url, { headers: { Accept: 'application/json' } })
            .then(function (response) {
                return response.ok ? response.json() : null;
            })
            .then(function (data) {
                var detected = data && data.detected_values && data.detected_values.country;
                return detected && detected.handle ? detected.handle.toUpperCase() : null;
            })
            .catch(function () {
                return null;
            });
    }

    function cozyDetectedCountry() {
        return new Promise(function (resolve) {
            var waited = 0;

            (function poll() {
                var cozy = window.CozyCountryRedirect;
                if (window.CozyCountryRedirectLoaded && cozy && cozy.country) {
                    resolve(String(cozy.country).toUpperCase());
                    return;
                }
                if (waited >= COZY_TIMEOUT_MS) {
                    resolve(null);
                    return;
                }
                waited += COZY_POLL_MS;
                window.setTimeout(poll, COZY_POLL_MS);
            })();
        });
    }

    function detectCountry() {
        return shopifyDetectedCountry().then(function (code) {
            return code || cozyDetectedCountry();
        });
    }

    onReady(function () {
        var modal = document.querySelector('.currency-switch-modal');
        if (!modal) { return; }

        function close() {
            modal.classList.remove('active');
        }

        function onActivate(element, handler) {
            if (!element) { return; }
            element.addEventListener('click', handler);
            element.addEventListener('keydown', function (event) {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    handler(event);
                }
            });
        }

        onActivate(modal.querySelector('.close-modal'), close);
        onActivate(modal.querySelector('.currency-switch-continue'), close);
        onActivate(modal.querySelector('.open-switch'), function () {
            close();
            var list = document.querySelector('.cs-popup-wrap');
            if (list) { list.classList.add('active'); }
        });
        // A click on the dimmed backdrop, not on the popup itself.
        modal.addEventListener('click', function (event) {
            if (event.target === modal) { close(); }
        });
        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') { close(); }
        });

        if (seenThisSession()) { return; }

        var selected = (modal.getAttribute('data-selected-country') || '').toUpperCase();

        detectCountry().then(function (code) {
            // Unknown location, or already shopping where they are: nothing to say.
            if (!code || !selected || code === selected) { return; }

            modal.classList.add('active');
            // Marked on show, not on dismiss, so navigating away from an ignored
            // popup does not bring it back on the next page.
            markSeen();
        });
    });
})();
